import { of as observableOf } from 'rxjs';

import { switchMap, withLatestFrom } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Effect, Actions, ofType } from '@ngrx/effects';

import { Store } from '@ngrx/store';
import * as DeviceActions from '../actions/device.action';
import { IAppState } from '@app/store';

@Injectable()
export class DeviceEffects {
  constructor(private actions$: Actions, private store$: Store<IAppState>) {}
  @Effect()
  widthAsChange$ = this.actions$.pipe(
    ofType(DeviceActions.SET_VIEWPORT_WIDTH),
    withLatestFrom(this.store$),
    switchMap(response => {
      return observableOf({
        type: DeviceActions.SET_IS_XS_ONLY,
        payload: response[1].device.width
      });
    })
  );
  @Effect()
  widthAsChange1$ = this.actions$.pipe(
    ofType(DeviceActions.SET_VIEWPORT_WIDTH),
    withLatestFrom(this.store$),
    switchMap(response => {
      return observableOf({
        type: DeviceActions.SET_IS_SM_UP,
        payload: response[1].device.width
      });
    })
  );
  @Effect()
  widthAsChange2$ = this.actions$.pipe(
    ofType(DeviceActions.SET_VIEWPORT_WIDTH),
    withLatestFrom(this.store$),
    switchMap(response => {
      return observableOf({
        type: DeviceActions.SET_IS_SM_ONLY,
        payload: response[1].device.width
      });
    })
  );
  @Effect()
  widthAsChange3$ = this.actions$.pipe(
    ofType(DeviceActions.SET_VIEWPORT_WIDTH),
    withLatestFrom(this.store$),
    switchMap(response => {
      return observableOf({
        type: DeviceActions.SET_IS_MD_UP,
        payload: response[1].device.width
      });
    })
  );
  @Effect()
  widthAsChange4$ = this.actions$.pipe(
    ofType(DeviceActions.SET_VIEWPORT_WIDTH),
    withLatestFrom(this.store$),
    switchMap(response => {
      return observableOf({
        type: DeviceActions.SET_IS_MD_ONLY,
        payload: response[1].device.width
      });
    })
  );
  @Effect()
  widthAsChange5$ = this.actions$.pipe(
    ofType(DeviceActions.SET_VIEWPORT_WIDTH),
    withLatestFrom(this.store$),
    switchMap(response => {
      return observableOf({
        type: DeviceActions.SET_IS_LG_UP,
        payload: response[1].device.width
      });
    })
  );
  @Effect()
  widthAsChange6$ = this.actions$.pipe(
    ofType(DeviceActions.SET_VIEWPORT_WIDTH),
    withLatestFrom(this.store$),
    switchMap(response => {
      return observableOf({
        type: DeviceActions.SET_IS_LG_ONLY,
        payload: response[1].device.width
      });
    })
  );
  @Effect()
  widthAsChange7$ = this.actions$.pipe(
    ofType(DeviceActions.SET_VIEWPORT_WIDTH),
    withLatestFrom(this.store$),
    switchMap(response => {
      return observableOf({
        type: DeviceActions.SET_IS_XL_UP,
        payload: response[1].device.width
      });
    })
  );
}
